import { createSlice } from "@reduxjs/toolkit";
import { normalizeBalance } from "../../services/helpers/balance-helper";

const balanceSlice = createSlice({
  name: "balance",
  initialState: { balance: 0 },
  reducers: {
    setBalanceValue(state, action) {
      state.balance = normalizeBalance(action.payload, 2);
    },
    // koristi se za primenu dobitka tek kada lopta padne
    addToBalance(state, action) {
      const delta = Number(action.payload) || 0;
      state.balance = normalizeBalance(Number(state.balance || 0) + delta, 2);
    },
    // ako već koristiš negde u kodu
    updateOnlyBalance(state, action) {
      const v = Number(action.payload);
      if (!Number.isNaN(v)) state.balance = normalizeBalance(v, 2);
    },
  },
});

export const { setBalanceValue, addToBalance, updateOnlyBalance } = balanceSlice.actions;
export default balanceSlice.reducer;
